var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"banner_wrap"},[_c('img',{attrs:{"src":_vm.imgListurl}})]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }